import { useState } from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Button } from '../../components/ui/button';
import { FileText, CircleNotch } from '@phosphor-icons/react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('nx_token')}` } });

export default function CreatorPitchDeckPage() {
  const [generating, setGenerating] = useState(false);
  const [deck, setDeck] = useState(null);

  const handleGenerate = async () => {
    setGenerating(true);
    try { const r = await axios.post(`${API}/creator/pitch-deck`, {}, auth()); setDeck(r.data); toast.success('Pitch deck generated'); }
    catch { toast.error('Failed'); } finally { setGenerating(false); }
  };

  return (
    <DashboardLayout>
      <div className="space-y-5" data-testid="creator-pitch-deck">
        <div>
          <h1 className="font-display text-2xl font-black text-[var(--text-primary)] tracking-tight">AI Partnership Pitch Deck</h1>
          <p className="text-sm text-[var(--text-secondary)] mt-1">One-click PDF with verified SoM data, performance metrics, and case study</p>
        </div>
        <div className="nx-metric-card rounded-md text-center py-8">
          <FileText size={40} className="mx-auto mb-3 text-[var(--text-tertiary)]" />
          <div className="flex items-center justify-center gap-4 mb-4 text-[9px] text-[var(--text-tertiary)] font-mono">
            <span>Page 1: Identity + QR</span><span>Page 2: Performance</span><span>Page 3: LinkedIn</span><span>Page 4: Case Study</span>
          </div>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded bg-[var(--neutral-bg)] mb-4">
            <span className="encrypted-badge">PDF Watermark</span>
            <span className="text-[8px] text-[var(--text-tertiary)] font-mono">Martian logo in footer + QR code page 1</span>
          </div>
          <br />
          <Button onClick={handleGenerate} disabled={generating} className="bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white">
            {generating ? <CircleNotch size={16} className="animate-spin mr-2" /> : <FileText size={16} className="mr-2" />}Generate My Pitch Deck
          </Button>
        </div>
        {deck && (
          <div className="nx-metric-card rounded-md animate-fade-in-up">
            <h3 className="text-sm font-bold text-[var(--text-primary)] mb-3">Generated Deck Preview</h3>
            <div className="grid grid-cols-2 gap-3">
              <div className="p-3 rounded border border-[var(--border)]"><p className="text-[9px] text-[var(--text-tertiary)]">SoM</p><p className="text-lg font-bold text-[var(--accent)] font-mono">{deck.pages?.identity?.som}%</p></div>
              <div className="p-3 rounded border border-[var(--border)]"><p className="text-[9px] text-[var(--text-tertiary)]">Revenue (90d)</p><p className="text-lg font-bold text-[var(--success)] font-mono">INR {deck.pages?.performance?.revenue_90d?.toLocaleString()}</p></div>
              {deck.pages?.linkedin && <div className="p-3 rounded border border-[var(--border)]"><p className="text-[9px] text-[var(--text-tertiary)]">LI Citation Rate</p><p className="text-lg font-bold text-[var(--text-primary)] font-mono">{deck.pages.linkedin.ai_citation_rate}%</p></div>}
              {deck.pages?.linkedin && <div className="p-3 rounded border border-[var(--border)]"><p className="text-[9px] text-[var(--text-tertiary)]">LI Followers</p><p className="text-lg font-bold text-[var(--text-primary)] font-mono">{deck.pages.linkedin.followers?.toLocaleString()}</p></div>}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
